/* Control 33 change 1: sticky 'Shop [product]' CTA -> the live Shopify purchase block (size/price + Add to cart). */
(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const go = target => {
    const header = document.querySelector('header.header');
    const offset = (header ? header.offsetHeight : 0) + 16;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({top: Math.max(0, top), behavior: reduced() ? 'auto' : 'smooth'});
    const focusable = target.querySelector('.sizes input:checked') || target.querySelector('.sizes input:not([disabled])') || target;
    focusable.focus({preventScroll: true});
  };
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href="#cb-purchase"]');
    if (!a || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const target = document.getElementById('cb-purchase');
    if (!target) return;
    e.preventDefault();
    go(target);
  });
})();
